<template>
  <p-list v-if="$hasPermission('skills.read')" />
  <p-not-found v-else />
</template>

<script>
import List from '@/components/skills/SkillsLibraryList.vue';
import NotFound from '@/components/NotFound.vue';

export default {
  components: {
    'p-list': List,
    'p-not-found': NotFound
  }
};
</script>
